import React, { useEffect, useState } from "react";
import api from "../api"; // your centralized API instance
import { Link } from "react-router-dom";

const BrandList = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await api.get("/api/all-brands");
        setBrands(response.data);
      } catch (err) {
        console.error("Failed to load brands:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  if (loading) return <p className="text-center py-5">Loading brands...</p>;

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">All Brands</h2>
      <div className="row g-4">
        {brands && brands.length > 0 ? (
          brands.map((brand) => (
            <div
              key={brand.id || brand.brandName}
              className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex justify-content-center"
            >
              <div className="brand-card text-center p-3 border rounded-3 bg-white shadow-sm">
                <Link to={`/products/brand/${encodeURIComponent(brand.brandName)}`}>
                  <img
                        src={
                            brand.brand_img_url && brand.brand_img_url.trim() !== ""
                            ? brand.brand_img_url
                            : "/images/default-brand.png" // ← your static fallback image
                        }
                        alt={brand.brandName}
                        className="img-fluid mb-2"
                        style={{ maxHeight: "100px", width:"150px", objectFit: "contain" }}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = "/images/no_image.jpg"; // fallback if broken URL
                        }}
                        />
                  <h6 className="mt-2 text-dark">{brand.brandName}</h6>
                </Link>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center">No brands found.</p>
        )}
      </div>
    </div>
  );
};

export default BrandList;
